import { render, staticRenderFns } from "./HouseholdSelection.vue?vue&type=template&id=62e04ca6&scoped=true&"
import script from "./HouseholdSelection.vue?vue&type=script&lang=js&"
export * from "./HouseholdSelection.vue?vue&type=script&lang=js&"
import style0 from "./HouseholdSelection.vue?vue&type=style&index=0&id=62e04ca6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e04ca6",
  null
  
)

export default component.exports